import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["content-marketing"];
export const Route = createFileRoute("/marketing/content-marketing")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} Services — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} Services — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/marketing/content-marketing" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/marketing/content-marketing" }],
  }),
});
